export default "__VITE_ASSET__abd752c6__"